var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Slider',{attrs:{"slides":_vm.shuffled,"title":"common.question"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var currentSlide = ref.currentSlide;
var ref_slide = ref.slide;
var answers = ref_slide.answers;
var correct_answer = ref_slide.correct_answer;
var nextSlide = ref.methods.nextSlide;
return [_c('div',{class:_vm.$style.answer_wrapper},_vm._l((answers),function(ref){
var id = ref.id;
var text = ref.text;
return _c('div',{class:[_vm.$style.answer, 'btn'],domProps:{"innerHTML":_vm._s(_vm.$options.filters.translate(text))},on:{"click":function($event){return _vm.answer(id, correct_answer, currentSlide, nextSlide)}}})}),0)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }